import { FC } from 'react'

import { Box, Button } from '@factorialco/deprecated-design-system'

import './index.styles.css'
type DisabledConfig = {
  zoomIn: boolean
  zoomToFit: boolean
  zoomOut: boolean
}

interface Props {
  onClick: (amount: number) => void
  onZoomToFit: () => void
  disabled?: DisabledConfig
}

const ZOOM_IN = 1.4
const ZOOM_OUT = 0.6

const ZoomControls: FC<Props> = ({ disabled, onClick, onZoomToFit }) => {
  const handleZoomIn = () => {
    onClick(ZOOM_IN)
  }

  const handleZoomOut = () => {
    onClick(ZOOM_OUT)
  }

  const handleZoomToFit = () => {
    onZoomToFit()
  }

  return (
    <Box flexDirection="row" gap="s4" className={'ZoomControls_zoomControls'}>
      <Button
        type="secondary"
        onClick={handleZoomOut}
        disabled={disabled?.zoomOut}
        iconName="remove"
        aria-label="Zoom out"
      />
      <Button type="secondary" disabled={disabled?.zoomToFit} onClick={handleZoomToFit}>
        Zoom to Fit
      </Button>
      <Button
        type="secondary"
        disabled={disabled?.zoomIn}
        onClick={handleZoomIn}
        iconName="add"
        aria-label="Zoom in"
      />
    </Box>
  )
}

export default ZoomControls
